import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { resetPasswordApi, forgotPasswordApi } from "../../api/auth.api";
import { toast } from "react-toastify";
import OtpInput from "../../components/OtpInput/OtpInput";
import PasswordStrength from "../../components/PasswordStrength/PasswordStrength";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function ResetPassword() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const email = state?.email;

  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    if (!email) {
      toast.error("Please request OTP first");
      navigate("/forgot-password", { replace: true });
    }
  }, [email, navigate]);

  useEffect(() => {
    if (timer === 0) {
      setCanResend(true);
      return;
    }
    const interval = setInterval(() => setTimer((t) => t - 1), 1000);
    return () => clearInterval(interval);
  }, [timer]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (otp.length !== 6) {
      toast.error("Enter 6-digit OTP");
      return;
    }
    setLoading(true);
    try {
      await resetPasswordApi({
        email,
        otp,
        newPassword: password,
      });
      toast.success("Password reset successful");
      navigate("/login");
    } catch (err) {
      toast.error(err.message || "Invalid or expired OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    try {
      await forgotPasswordApi(email);
      toast.success("OTP resent");
      setOtp("");
      setTimer(60);
      setCanResend(false);
    } catch {
      toast.error("Failed to resend OTP");
    }
  };

  if (!email) return null;

  return (
    <div className="auth-card" style={{ maxWidth: 420 }}>
      <h1 className="auth-title">Reset Password</h1>

      <form onSubmit={handleSubmit}>
        <div className="auth-field">
          <label className="auth-label">Enter 6-digit OTP</label>
          <OtpInput value={otp} onChange={setOtp} />
        </div>

        <div className="auth-field">
          <div className="auth-input-wrap">
            <input
              className="auth-input"
              type={showPassword ? "text" : "password"}
              placeholder="New password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="auth-toggle-pwd"
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
            </button>
          </div>
        </div>

        <PasswordStrength password={password} />

        <button
          type="submit"
          disabled={loading}
          className="auth-btn"
        >
          {loading ? "Resetting..." : "Reset Password"}
        </button>

        <div className="auth-resend">
          {canResend ? (
            <button type="button" onClick={handleResend}>
              Resend OTP
            </button>
          ) : (
            <span>Resend OTP in {timer}s</span>
          )}
        </div>
      </form>
    </div>
  );
}
